/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React TS Base Styles
import colors from 'src/assets/md-theme/base/colors';
import boxShadows from 'src/assets/md-theme/base/boxShadows';
import borders from 'src/assets/md-theme/base/borders';

const { white } = colors;
const { md } = boxShadows;
const { borderRadius, borderColor } = borders;

// types
type Types = any;

const tableContainer: Types = {
  styleOverrides: {
    root: {
      position: 'relative',
      width: '100%',
      backgroundColor: white.main,
      borderRadius: borderRadius.md,
      border: `1px solid ${borderColor}`,
    },
  },
};

export default tableContainer;
